class ImageCacheService {
    constructor() {
        this.cache = new Map();
    }

    set(id, data) {
        this.cache.set(id, data);
    }

    get(id) {
        return this.cache.get(id);
    }

    has(id) {
        return this.cache.has(id);
    }

    clear() {
        this.cache.clear();
    }
}

export const imageCacheService = new ImageCacheService();
